import { render, staticRenderFns } from "./LmFormSeparator.vue?vue&type=template&id=35fdca18&scoped=true&"
var script = {}
import style0 from "./LmFormSeparator.vue?vue&type=style&index=0&id=35fdca18&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fdca18",
  null
  
)

export default component.exports